import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
import ChatIcon from '@mui/icons-material/Chat';
import ContactChannelButton from '../ContactButton/ContactChannelButton';
export default function PageMain() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: translate("feedback.global.topic.mentorship"),
      href: "#"
    }, {
      title: "OpenClassrooms",
      href: "#"
    }, {
      title: translate("feedback.global.topic.validation.title"),
      subtitle: translate("feedback.global.topic.validation.subtitle"),
      href: "#"
    }, {
      title: translate("feedback.global.topic.diploma.title"),
      subtitle: translate("feedback.global.topic.diploma.subtitle"),
      href: "#"
    }, {
      title: translate("feedback.global.topic.other"),
      href: "#"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const topics = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="h2">{translate("feedback.global.title")}</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Stack spacing={2}>{t1}<Typography variant="body1">{translate("feedback.global.subtitle")}</Typography></Stack>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack spacing={4}>{t2}<Stack spacing={2}>{topics.map(_temp)}</Stack></Stack>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(topic) {
  return <ContactChannelButton key={topic.title} iconComponent={ChatIcon} href={topic.href} subTitle={topic?.subtitle}>{topic.title}</ContactChannelButton>;
}